import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=63dba2e6&scoped=true&"
import script from "./tableList.vue?vue&type=script&lang=js&"
export * from "./tableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dba2e6",
  null
  
)

export default component.exports